import JoyRideTour from './JoyRideTour';

export default JoyRideTour;
